import React from 'react';

type Props = {
    title?: string;
    desc?: string;
};

const NotificationBanner: React.FC<Props> = ({ title, desc }) => {
    return (
        <div className="bg-white mb-4 WorkSans p-4 border border-[#27AE60]">
            <p className="text-[#0F2240] WorkSans-Bold">{title}</p>
            <label className="font-[Lato]">{desc}</label>
        </div>
    );
};

export default NotificationBanner;
